<script setup lang="ts">
defineProps<{ visible: boolean }>();
defineEmits<{ 'update:visible': [value: boolean] }>();
</script>

<template>
  <a-drawer
    class="com-overlay-container"
    :visible="visible"
    :mask="false"
    :body-style="{ padding: 0 }"
    :closable="false"
    width="100vw"
    placement="left"
    position="left"
    @close="$emit('update:visible', false)"
  >
    <div class="drawer-overlay com-screen">
      <slot />
    </div>
  </a-drawer>
</template>

<style lang="less" scoped>
.drawer-overlay {
  width: 100vw;
  height: 100vh;
  background: @color-background-dark;
  padding: 27px 24px;
}
</style>
